module.exports = "/src/views/eternal-dev/containers/pictures/coin.svg";